import { useSelector } from "react-redux";
import TutorialPopover from "../components/NavigationBottom/TutorialNav/TutorialPopover/TutorialPopover";
import { setSettingsPage } from "../redux/settings/slice";
import { selectLegalPersonType } from "../redux/settings/selectors";

const styles = {
  // весь тултіп
  helper: (defaultStyles, state) => ({
    ...defaultStyles,
    background: "#333",
    color: "#fff",
    borderRadius: "10px",
    // padding: "20px",
  }),
  // поповер всередині тултіпа
  popover: defaultStyles => ({
    ...defaultStyles,
    fontSize: "16px",
    fontWeight: "bold",
    background: " #222630",
    border: "solid 1px var(--white)",
    borderRadius: "5px",
    width: "clamp(232px, min(18.108vw, 31.019vh), 335px)",
    padding: "clamp(14px, min(1.081vw, 1.852vh), 20px)",
  }),
  // маска/overlay
  mask: defaultStyles => ({
    ...defaultStyles,
    background: "rgba(0,0,0,0.6)",
  }),
};

const DynamicTutorialContent = () => {
  const legalPersonType = useSelector(selectLegalPersonType);
  return (
    <TutorialPopover
      title={`Обов'язкові поля для заповнення ${
        legalPersonType === "ФОП" ? "ФОП" : "ТОВ"
      } `}
      content={`Назва, ІПН, рахунок IBAN ${
        legalPersonType === "ФОП" ? " " : ", ЄДРПОУ"
      }`}
      modalStep={true}
    />
  );
};

// Settings Page

export const settingsSteps = [
  {
    selector: '[data-tour="step-0"]',
    content: () => (
      <TutorialPopover
        title="Налаштування Автосервісу"
        content={
          <>
            В даному блоці відображаються всі доступні вам автосервіси. Для
            перемикання між автосервісами просто клікніть по стрілці біля назви
            необхідного автосервісу
            <br />
            <br />
            Якщо в налаштуваннях доступу вам не доступний перегляд автосервісів,
            то цей блок буде порожнім.
          </>
        }
        disabledNext={false}
        disabledBack={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour="step-1"]',
    content: () => (
      <TutorialPopover
        title="Налаштування Автосервісу"
        content={
          <>
            Натисніть на олівець та перейдіть в редагування автосервісу.
            <br />
            <br />
            Якщо в налаштуваннях доступу вам не доступні перегляд та редагування
            австосервісу, то ця кнопка буде відсутня і ви не матимете можливості
            редагувати дані автосервісу.
          </>
        }
        disabledNext={true}
        disabledBack={true}
      />
    ),
    styles: styles,
    highlightedSelectors: [".ReactModal__Content"],
    mutationObservables: [".ReactModal__Overlay"],
    pulse: true,
    stepInteraction: true,
    // position: "top-end",
  },
  {
    selector: '[data-tour="step-2"]',
    content: () => (
      <TutorialPopover
        title="Модальне вікно редагування автосервісу"
        content="У вікні, що відкриється, можна змінити наявні дані або додати нові"
        disabledBack={true}
        modalStep={true}
      />
    ),
    styles,
    position: "top-start",

    highlightedSelectors: [".ReactModal__Content"],
    mutationObservables: [".ReactModal__Content", ".ReactModal__Overlay"],
    resizeObservables: [".ReactModal__Content"],

    // критично важливо:
    disableInteraction: true,
  },
  {
    selector: '[data-tour="step-3"]',
    content: () => (
      <TutorialPopover
        content="Завантажте логотип, відредагуйте назву, адресу або контактні дані"
        modalStep={true}
      />
    ),
    styles: styles,
  },

  {
    selector: '[data-tour="step-4"]',
    content: () => (
      <TutorialPopover
        content="Для збереження натисніть 'Зберегти'"
        modalStep={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour="step-5"]',
    content: () => (
      <TutorialPopover
        content="Для відміни та виходу з модального вікна натисніть 'Закрити'"
        disabledNext={true}
        modalStep={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour="step-6"]',
    content: () => (
      <TutorialPopover
        title="Додавання юр.особи"
        content={
          <>
            Натисніть на кнопку з зображенням плюса та перейдіть в модальне
            вікно додавання юр.особи.
            <br />
            <br />
            Якщо в налаштуваннях доступу вам не доступний даний функціонал, то
            ця кнопка буде відсутня і ви не матимете можливості додавати
            юр.особу.
          </>
        }
        disabledNext={true}
        currentBackStep={0}
        skipPart={true}
      />
    ),
    styles: styles,
    highlightedSelectors: [".ReactModal__Content"],
    mutationObservables: [".ReactModal__Overlay"],
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour="step-7"]',
    content: () => (
      <TutorialPopover
        title="Mодальне вікно додавання юр.особи"
        disabledBack={true}
        modalStep={true}
      />
    ),
    styles: styles,
  },

  {
    selector: '[data-tour="step-7.1"]',
    content: () => (
      <TutorialPopover
        content="В селекторі оберіть тип юридичної особи. Це вплине на обов'язкові до заповнення данні."
        modalStep={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
  },
  {
    selector: '[data-tour="step-7.2"]',
    content: () => <DynamicTutorialContent />,
    styles: styles,
  },
  {
    selector: '[data-tour="step-8"]',
    content: () => (
      <TutorialPopover
        content="Для збереження натисніть 'Зберегти'"
        modalStep={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour="step-9"]',
    content: () => (
      <TutorialPopover
        content="Для відміни та виходу з модального вікна натисніть 'Закрити'"
        disabledNext={true}
        modalStep={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour="step-10"]',
    content: () => (
      <TutorialPopover
        title="Список юридичних осіб"
        content="Створену юридичну особу буде додано до списку"
        currentBackStep={5}
        skipPart={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour="step-10.1"]',
    content: () => (
      <TutorialPopover
        content={
          <>
            Щоб відредагувати юридичну особу натисніть на кнопку з зображенням
            олівця.
            <br />
            Після цього відкриється модальне вікно, аналогічне модальному вікну
            додавання.
            <br />
            <br />
            Якщо в налаштуваннях доступу вам не доступне редагування юр.особи,
            то ця кнопка буде відсутня і ви не матимете можливості редагувати
            юр.особу.
          </>
        }
      />
    ),
    styles: styles,
  },
];

// ! Створення автосервісу
export const createServiceSteps = [
  {
    selector: '[data-tour-create-service="step-1"]',
    content: () => (
      <TutorialPopover
        title="Додавання Автосервісу"
        content={
          <>
            Натисніть на кнопку, щоб відкрити модальне вікно для створення
            автосервісу.
            <br />
            <br />
            Якщо в налаштуваннях доступу вам не доступний даний функціонал, то
            ця кнопка буде відсутня і ви не матимете можливості створювати
            автосервіси.
          </>
        }
        disabledNext={true}
        // disabledBack={true}
      />
    ),
    styles: styles,
    highlightedSelectors: [".ReactModal__Content"],
    mutationObservables: [".ReactModal__Overlay"],
    pulse: true,
    position: "top",
    stepInteraction: true,
  },
  {
    selector: '[data-tour="step-2"]',
    content: () => (
      <TutorialPopover
        title="Модальне вікно додавання автосервісу"
        content="У вікні, що відкриється, можна додати дані нового автосервіса."
        disabledBack={true}
        modalStep={true}
      />
    ),
    styles,
    position: "top-start",

    highlightedSelectors: [".ReactModal__Content"],
    mutationObservables: [".ReactModal__Content", ".ReactModal__Overlay"],
    resizeObservables: [".ReactModal__Content"],

    // критично важливо:
    disableInteraction: true,
  },
  {
    selector: '[data-tour="step-3"]',
    content: () => (
      <TutorialPopover
        // content="Завантажте логотип"
        content="Додайте логотип, вкажіть назву, адресу, Юр особу (ФОП або ТОВ), ІПН, банківські реквізити, юридичну адресу
"
        modalStep={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour="step-4"]',
    content: () => (
      <TutorialPopover
        content="Для збереження натисніть 'Зберегти'"
        modalStep={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour="step-5"]',
    content: () => (
      <TutorialPopover
        content="Для відміни та виходу з модального вікна натисніть 'Закрити'"
        disabledNext={true}
        modalStep={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-create-service="step-6"]',
    content: () => (
      <TutorialPopover
        content="Створений автосервіс буде додано в список"
        currentBackStep={0}
        skipPart={true}
      />
    ),
    styles: styles,
  },
];

// ! Налаштування робочого графіку сервісу
export const stepsSchedule = [
  {
    selector: '[data-tour-schedule="step-1"]',
    content: () => (
      <TutorialPopover
        title="Налаштування робочого графіку"
        content="Щоб відкрити таблицю графіка, натисніть на Стрілку."
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-schedule="step-2"]',
    content: () => (
      <TutorialPopover
        title="Налаштування робочого графіку"
        content={
          <>
            Щоб відкрити редагування, натисніть на кнопку з зображенням Олівця.
            <br />
            <br />
            Якщо в налаштуваннях доступу вам не доступне редагування
            автосервісів, то ця кнопка буде відсутня і ви не матимете
            возможности редагувати робочий графік.
          </>
        }
        disabledNext={true}
        disabledBack={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-schedule="step-3"]',
    content: () => (
      <TutorialPopover
        title="Налаштування робочого графіку"
        content="Відредагуйте наявний графік або встановіть новий. Щоб обрати необхідну годину - клікніть по відповідні клітинці, повторний клік знімає вибір"
        disabledBack={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-schedule="step-4"]',
    content: () => (
      <TutorialPopover
        title="Налаштування робочого графіку"
        content="Щоб зберегти зміни, натисніть на кнопку з зображенням Дискети "
      />
    ),
    styles: styles,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-schedule="step-5"]',
    content: () => (
      <TutorialPopover
        title="Налаштування робочого графіку"
        content="Щоб скинути зміни та закрити редагування, натисніть на кнопку з зображенням Хрестика "
      />
    ),
    styles: styles,
  },
];

// ! Налаштування постачальників
export const settingsStepsSuppliers = dispatch => [
  {
    selector: '[data-tour="step-11"]',
    content: () => (
      <TutorialPopover
        title="Налаштування постачальників"
        content={
          <>
            Дана вкладка дозволяє комплексно керувати та налаштовувати
            постачальників.
            <br />
            <br />
            Якщо у вас немає доступу до перегляду налаштувань постачальників, ця
            вкладка буде відсутня.
          </>
        }
      />
    ),
    styles: styles,
    action: () => dispatch(setSettingsPage("distributors")),
  },
  {
    selector: '[data-tour="step-12"]',
    content: () => (
      <TutorialPopover
        title="Налаштування постачальників"
        content={
          <>
            Тут можна додати нового постачальника або імпортувати власну базу
            постачальників, відредагувати дані існуючого або видалити
            постачальника, ввести борги.
          </>
        }
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour="step-13"]',
    content: () => (
      <TutorialPopover
        title="Додавання постачальника"
        content={
          <>
            Додавання постачальника можливе двома способами: вручну або імпортом
            власної бази постачальників з excel-файлу.
            <br />
            <br />
            Якщо у вас немає прав для створення постачальників, цей блок буде
            відсутній.
          </>
        }
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour="step-14"]',
    content: () => (
      <TutorialPopover
        title="Додавання постачальника"
        content="Щоб додати постачальника вручну, відкрийте модальне вікно додавання постачальника"
        disabledNext={true}
      />
    ),
    styles: styles,
    highlightedSelectors: [".ReactModal__Content"],
    mutationObservables: [".ReactModal__Overlay"],
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour="step-16"]',
    content: () => (
      <TutorialPopover
        title="Обов'язкові до заповнення поля"
        content="Обов'язковим полем для створення постачальника є Назва, решта полів заповнюються за бажанням. Після заповнення натисніть 'Зберегти'"
        disabledBack={true}
        // modalStep={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour="step-19"]',
    content: () => (
      <TutorialPopover
        content="Також можна додати сайт та email постачальника."
        // modalStep={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour="step-22"]',
    content: () => (
      <TutorialPopover
        content="Для збереження натисніть 'Зберегти'"
        // modalStep={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour="step-23"]',
    content: () => (
      <TutorialPopover
        content="Для відміни та виходу з модального вікна натисніть 'Закрити'"
        disabledNext={true}
        // modalStep={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour="step-24"]',
    content: () => (
      <TutorialPopover
        title="Додавання постачальників"
        content="Для імпорту власної бази постачальників спочатку скачайте шаблон, заповніть його та завантажте назад в систему. Всі ваші постачальники будуть автоматично додані в список."
        currentBackStep={1}
        skipPart={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-posts="step-4"]',
    content: () => (
      <TutorialPopover
        content="Щоб відредагувати постачальника натисніть на кнопку з Олівцем. Відкриється модальне вікно, в якому можна змінити дані постачальника."
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour="step-17"]',
    content: () => (
      <TutorialPopover
        content={
          <>
            Щоб видалити постачальника натисніть на 3 крапочки, потім в
            випадаючому меню оберіть Видалити.
            <br />
            <br />
            Якщо постачальник підключений через API, то його не можна видалити.
            Також якщо у вас немає прав для видалення постачальників, то кнопка
            Видалити буде відсутня.
          </>
        }
        // modalStep={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-connection="step-17"]',
    content: () => (
      <TutorialPopover
        content="Якщо постачальник підключений через API, то в правому блоку будуть налаштування доступу до його АРІ. Вам треба ввести логін, пароль або АРІ-ключ у відповідні поля (залежно від того, який тип підключення використовує постачальник). Після введення даних натисніть 'Тест' для перевірки підключення."
        // modalStep={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-editing="step-18"]',
    content: () => (
      <TutorialPopover content="Для збереження натисніть 'Зберегти'" />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-editing="step-19"]',
    content: () => (
      <TutorialPopover
        content="Або для відміни та виходу з модального вікна натисніть 'Закрити'"
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-posts="step-11"]',
    content: () => (
      <TutorialPopover
        // title="Частина пости"
        content="Щоб вимкнути постачальника натисніть іконку 'Вимкнути'. Після цього постачальник стане неактивним і не буде задіяний в підборі запчастин, а також буде недоступний в документах надходжень і замовлень."
        // disabledNext={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-debts="step-11"]',
    content: () => (
      <TutorialPopover
        // title="Частина пости"
        content={
          <>
            Для введення боргів постачальникам натисніть на відповідну кнопку,
            відкриється модальне вікно.
            <br />
            <br />
            Якщо у вас немає прав для редагування постачальників, то ця кнопка
            буде відсутня.
          </>
        }
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-debts="step-12"]',
    content: () => (
      <TutorialPopover
        // title="Частина пости"
        content={
          <>
            У вікні, що відкриється, можна ввести суму боргу відповідному
            постачальнику.
          </>
        }
        // disabledNext={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-debts="step-13"]',
    content: () => (
      <TutorialPopover
        // title="Частина пости"
        content={<>Для цього клікніть по кнопці з зображенням Олівця.</>}
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-debts="step-14"]',
    content: () => (
      <TutorialPopover
        // title="Частина пости"
        content={
          <>
            Введіть необхідну суму боргу в інпут (можна ввести як плюсове, так і
            від'ємне число, залежно від того, хто кому винен).
          </>
        }
        disabledNext={false}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-debts="step-15"]',
    content: () => (
      <TutorialPopover
        // title="Частина пости"
        content={
          <>Та натисніть кнопку з зображенням Дискетки для збереження.</>
        }
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-debts="step-16"]',
    content: () => (
      <TutorialPopover
        // title="Частина пости"
        content={
          <>Для збереження внесених змін натисніть кнопку з "Зберегти"</>
        }
        disabledNext={false}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-debts="step-17"]',
    content: () => (
      <TutorialPopover
        // title="Частина пости"
        content={
          <>
            Або кнопку "Закрити" для відміни змін і виходу з модального вікна.
          </>
        }
        disabledNext={true}
      />
    ),
    styles: styles,
  },
];

export const settingsStepsPosts = dispatch => [
  {
    selector: '[data-tour-posts="step-1"]',
    content: () => (
      <TutorialPopover
        title="Налаштування постів"
        content="Відредагуйте необхідний пост, додайте новий, видаліть існуючий або пропустіть налаштування"
      />
    ),
    styles: styles,
    action: () => dispatch(setSettingsPage("station")),
  },
  // {
  //   selector: '[data-tour-posts="step-2"]',
  //   content: () => (
  //     <TutorialPopover
  //       title="Частина пости"
  //       // content="Натисніть на кнопку, щоб перейти в потрібний розділ"
  //     />
  //   ),
  //   styles: styles,
  // },
  {
    selector: '[data-tour-posts="step-3"]',
    content: () => (
      <TutorialPopover
        title="Список постів"
        content="В списку всіх постів знаходиться інформація про назву поста, можливість його відредагувати, видалити або вимкнути"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-posts="step-4"]',
    content: () => (
      <TutorialPopover
        // title="Частина пости"
        content="Щоб відредагувати пост натисніть на кнопку з Олівцем"
        disabledNext={false}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-posts="step-8"]',
    content: () => (
      <TutorialPopover
        // title="Частина пости"
        content="Щоб видалити пост натисніть на кнопку з Корзиною, після чого відкриється модальне вікно підтвердження, де потрібно буде підтвердити видалення."
        disabledNext={false}
      />
    ),
    styles: styles,
  },

  {
    selector: '[data-tour-posts="step-11"]',
    content: () => (
      <TutorialPopover
        // title="Частина пости"
        content="Щоб вимкнути пост натисніть іконку 'Вимкнути', після чого пост стане неактивним і його не буде видно в списку постів при створенні запису на сервіс."
        // disabledNext={true}
      />
    ),
    styles: styles,
  },

  {
    selector: '[data-tour-posts="step-13"]',
    content: () => (
      <TutorialPopover
        title="Додавання поста"
        content="Введіть назву нового поста."
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-posts="step-14"]',
    content: () => (
      <TutorialPopover
        title="Додавання поста"
        content="Натисніть 'Додати'. Збережений пост відобразиться в списку."
      />
    ),
    styles: styles,
  },
];

export const settingsStepsStaff = dispatch => [
  {
    selector: '[data-tour-staff="step-1"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте персонал"
        content="Відредагуйте необхідного працівника, додайте нового, видаліть існуючого або пропустіть налаштування"
      />
    ),
    styles: styles,
    action: () => dispatch(setSettingsPage("staff")),
  },
  {
    selector: '[data-tour-staff="step-3"]',
    content: () => (
      <TutorialPopover
        title="Додайте працівника"
        content="Відкрийте модальне вікно додавання працівника"
        disabledNext={true}
      />
    ),
    styles: styles,
    highlightedSelectors: [".ReactModal__Content"],
    mutationObservables: [".ReactModal__Overlay"],
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-staff="step-4"]',
    content: () => (
      <TutorialPopover
        title="Додайте працівника"
        content="Обов'язковими даними для створення працівника є ім'я та прізвище, номер телефону, електронна пошта, сума та метод нарахування заробітної плати. Також обов'язково згенеруйте логін та пароль."
        disabledBack={true}
        // modalStep={true}
      />
    ),
    styles: styles,
  },

  {
    selector: '[data-tour-staff="step-5"]',
    content: () => (
      <TutorialPopover
        title="Додайте працівника"
        content="Згенеруйте логін і пароль (вони прийдуть їм на електрону пошту для активації мобільного додатку для механіка). Щоб створити логін і пароль натисніть кнопку 'Згенерувати'. при бажанні можна вручну змінити/додати логін та пароль. "
        // modalStep={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-staff="step-6"]',
    content: () => (
      <TutorialPopover
        title="Додайте працівника"
        content="Підвантажте документацію."
        modalStep={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-staff="step-7"]',
    content: () => (
      <TutorialPopover
        title="Додайте працівника"
        content="Заповніть зарплатні дані працівника"
        // modalStep={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-staff="step-8"]',
    content: () => (
      <TutorialPopover
        title="Додайте працівника"
        content="При потребі додайте робочий графік"
        modalStep={true}
      />
    ),
    styles: styles,
  },

  {
    selector: '[data-tour-staff="step-9"]',
    content: () => (
      <TutorialPopover
        content="Для збереження натисніть 'Зберегти'"
        modalStep={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-staff="step-10"]',
    content: () => (
      <TutorialPopover
        // title="Налаштуйте Постачальників"
        content="Для відміни та виходу з модального вікна натисніть 'Закрити'"
        disabledNext={true}
        modalStep={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },

  {
    selector: '[data-tour-staff="step-11"]',
    content: () => (
      <TutorialPopover
        title="Список працівників"
        content="В списку всіх працівників знаходиться інформація про постачальника, можливість його відредагувати, видалити або вимкнути"
        currentBackStep={1}
        skipPart={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-posts="step-4"]',
    content: () => (
      <TutorialPopover
        // title="Частина пости"
        content="Щоб відредагувати працівника натисніть на кнопку з Олівцем"
        disabledNext={false}
      />
    ),
    styles: styles,
    pulse: true,
  },
  {
    selector: '[data-tour-posts="step-8"]',
    content: () => (
      <TutorialPopover
        // title="Частина пости"
        content="Щоб видалити працівника натисніть на кнопку з Корзиною, після чого відкриється модальне вікно підтвердження, де потрібно буде підтвердити видалення."
        disabledNext={false}
      />
    ),
    styles: styles,
    // highlightedSelectors: [".ReactModal__Content"],
    // mutationObservables: [".ReactModal__Overlay"],
    pulse: true,
  },
  {
    selector: '[data-tour-posts="step-11"]',
    content: () => (
      <TutorialPopover
        // title="Частина пости"
        content="Щоб вимкнути працівника натисніть іконку 'Вимкнути', після чого працівник стане неактивним."
        // disabledNext={true}
      />
    ),
    styles: styles,
  },
];

export const settingsStepsPrice = dispatch => [
  {
    selector: '[data-tour-price="step-1"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте прайс послуг"
        content="Оберіть відповідний розділ"
      />
    ),
    styles: styles,
    action: () => dispatch(setSettingsPage("price")),
  },
  {
    selector: '[data-tour-price="step-2"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте прайс послуг"
        content="В розділі послуги знаходяться обов'язкові категорії послуг, які відображаються в записі на сервіс та впливають на статуси машинозаїздів"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-price="step-3"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте прайс послуг"
        content="Обов'язковими категоріями є діагностика та ремонт"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-price="step-4"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте прайс послуг"
        content="В кінці кожної гілки знаходяться три крапки, по кліку на які відкривається невелике меню з можливими діями"
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-price="step-5"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте прайс послуг"
        content={
          <>
            Натисніть редагувати, щоб відредагувати назву категорії
            <br />
            <br />
            Натисніть додати, щоб додати нову послугу до обраної категорії
          </>
        }
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-price="step-6"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте прайс послуг"
        content="Натисніть на категорію, щоб відкрити її"
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-price="step-7"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте прайс послуг"
        content="Відкривши категорію, ви знайдете список всіх послуг"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-price="step-8"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте прайс послуг"
        content="В кінці кожного рядка з послугою є три крапки, по кліку на які відкривається невелике меню з можливими діями"
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },

  {
    selector: '[data-tour-price="step-5"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте прайс послуг"
        content={
          <>
            Натисніть редагувати, щоб відредагувати назву послуги або її ціну
            <br />
            <br />
            Натисніть видалити, щоб видалити послугу
          </>
        }
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-price="step-9"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте прайс послуг"
        content={
          <>
            В розділах 'Заміна запчастин' та 'Інші послуги' все працює
            аналогічно розділу 'Послуги', але також з'являється можливість
            додати нову категорію
            <br />
            <br />
            Оберіть будь-який розділ
          </>
        }
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-price="step-10"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте прайс послуг"
        content="Натисніть на кнопку 'Нова група', щоб додати нову категорію"
      />
    ),
    styles: styles,
  },
  {
    // selector: '[data-tour-price="step-10"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте прайс послуг"
        content="Після всіх внесених змін обов'язково натисніть кнопку 'Зберегти', для збереження змін"
      />
    ),
    styles: styles,
    position: "center",
  },
];

export const settingsStepsWarehouse = dispatch => [
  {
    selector: '[data-tour-warehouse="step-1"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте склади"
        content="Оберіть відповідний розділ"
      />
    ),
    styles: styles,
    action: () => dispatch(setSettingsPage("warehouse")),
  },
  {
    selector: '[data-tour-warehouse="step-2"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте склади"
        content="Щоб створити новий склад натисніть на кнопку 'Новий склад'"
        disabledNext={true}
      />
    ),
    styles: styles,
    highlightedSelectors: [".ReactModal__Content"],
    mutationObservables: [".ReactModal__Overlay"],
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-warehouse="step-3"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте склади"
        content="В модальному вікні введіть назву складу"
        disabledBack={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-warehouse="step-4"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте склади"
        content="Для збереження складу натисніть 'Зберегти'"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-warehouse="step-5"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте склади"
        content="Для відміни та виходу з модального вікна натисніть 'Закрити'"
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-warehouse="step-6"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте склади"
        content="Натисніть на три крапки, що розташовані в кінці кожної гілки дерева, щоб відкрити меню для редагування, видалення або додавання нової частини складу"
        disabledNext={true}
        skipPart={true}
        currentBackStep={1}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-warehouse="step-7"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте склади"
        content={
          <>
            Натисніть додати, щоб додати секцію/стелаж/полицю/місце
            <br />
            <br />
            Натисніть редагувати, щоб відредагувати назву
            склада/секції/стелажа/полиці/місця
            <br />
            <br />
            Натисніть видалити, щоб видалити склад/секцію/стелаж/полицю/місце
          </>
        }
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-warehouse="step-8"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте склади"
        content="Натисніть 'Зберегти' для збереження всіх змін"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-warehouse="step-9"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте склади"
        content={
          <>
            Для перегляду секцій складу, натисніть на саму гілочку з складом.
            <br />
            <br />
            Натисніть на гілочку.
          </>
        }
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-warehouse="step-9"]',
    content: () => (
      <TutorialPopover title="Налаштуйте склади" content="Натисніть далі" />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-warehouse="step-10"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте склади"
        content="Виконайте аналогічні дії з наступними гілочками, для перегляду інших частин складу"
      />
    ),
    styles: styles,
  },
];

export const settingsStepsCashRegisters = dispatch => [
  {
    selector: '[data-tour-cashregister="step-1"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте каси"
        content="Оберіть відповідний розділ"
      />
    ),
    styles: styles,
    action: () => dispatch(setSettingsPage("checkout")),
  },
  {
    selector: '[data-tour-cashregister="step-2"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте каси"
        content="Щоб додати касу, натисніть кнопку 'Додати'"
        disabledNext={true}
      />
    ),
    styles: styles,

    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-cashregister="step-3"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте каси"
        content="Всі поля в модальному вікні обов'язкові до заповнення"
        disabledBack={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-cashregister="step-4"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте каси"
        content="Заповнивши всі поля, натисніть 'Зберегти' для додавання каси"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-cashregister="step-5"]',
    content: () => (
      <TutorialPopover
        title="Налаштуйте каси"
        content="Для відміни та виходу з модального вікна натисніть 'Закрити'"
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-cashregister="step-6"]',
    content: () => (
      <TutorialPopover
        title="Список кас"
        content="В списку всіх кас знаходиться інформація про касу, можливість її відредагувати, видалити або вимкнути"
        currentBackStep={1}
        skipPart={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-posts="step-4"]',
    content: () => (
      <TutorialPopover
        // title="Частина пости"
        content="Щоб відредагувати касу натисніть на кнопку з Олівцем"
        disabledNext={false}
      />
    ),
    styles: styles,
    pulse: true,
  },
  {
    selector: '[data-tour-posts="step-8"]',
    content: () => (
      <TutorialPopover
        // title="Частина пости"
        content="Щоб видалити касу натисніть на кнопку з Корзиною, після чого відкриється модальне вікно підтвердження, де потрібно буде підтвердити видалення."
        disabledNext={false}
      />
    ),
    styles: styles,
    // highlightedSelectors: [".ReactModal__Content"],
    // mutationObservables: [".ReactModal__Overlay"],
    pulse: true,
  },
  {
    selector: '[data-tour-posts="step-11"]',
    content: () => (
      <TutorialPopover
        // title="Частина пости"
        content="Щоб вимкнути касу натисніть іконку 'Вимкнути', після чого працівник стане неактивним."
        // disabledNext={true}
      />
    ),
    styles: styles,
  },
];

// Video-Control Page

export const videoControlStepsStatistic = [
  {
    selector: '[data-tour-vc-stat="step-1"]',
    content: () => (
      <TutorialPopover
        title="Статистика"
        content="Блок статистики показує дані щодо машинозаїздів"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-vc-stat="step-2"]',
    content: () => (
      <TutorialPopover
        title="Статистика"
        content="В частині 'Всього' розміщена загальна кількість машинозаїздів"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-vc-stat="step-3"]',
    content: () => (
      <TutorialPopover
        title="Статистика"
        content="В частині 'Готово' розміщена кількість закінчених машин"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-vc-stat="step-4"]',
    content: () => (
      <TutorialPopover
        title="Статистика"
        content="В частині 'У ремонті' розміщена кількість машин, що знаходяться в процесі ремонту"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-vc-stat="step-5"]',
    content: () => (
      <TutorialPopover
        title="Статистика"
        content="В частині 'На діагностиці' розміщена кількість машин, що проходять етап діагностики"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-vc-stat="step-6"]',
    content: () => (
      <TutorialPopover
        title="Статистика"
        content="В частині 'Нерозібрані' розміщена кількість машин, що чекають на початок робіт"
      />
    ),
    styles: styles,
  },
];

export const videoControlStepsCameras = [
  {
    selector: '[data-tour-vc-cam="step-1"]',
    content: () => (
      <TutorialPopover
        title="Камери"
        // content="Блок статистики показує дані щодо машинозаїздів"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-vc-cam="step-2"]',
    content: () => (
      <TutorialPopover
        title="Камери"
        content=" Цифри під зображенням з камер показують кількість встановлених камер на СТО та дають можливість перемикатися між ними клікнувши по бажаному номеру. Синім кольором показана активна камера, зображення з якої ви можете бачити перед собою"
      />
    ),
    styles: styles,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-vc-cam="step-3"]',
    content: () => (
      <TutorialPopover
        title="Камери"
        content="За допомогою стрілок «вліво» та «вправо» можна переглядати всі встановлені камери СТО."
      />
    ),
    styles: styles,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-vc-cam="step-4"]',
    content: () => (
      <TutorialPopover
        title="Камери"
        content="При необхідності можна оновити зображення з камери натиснувши на кнопку 'Оновити камери'"
      />
    ),
    styles: styles,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-vc-cam="step-5"]',
    content: () => (
      <TutorialPopover
        title="Камери"
        content="Усі автомобілі, що були зафіксовані камерами протягом дня, відображаються у списку під камерами."
      />
    ),
    styles: styles,
  },
];

export const carsChartSteps = [
  {
    selector: '[data-tour-cars-chart="step-1"]',
    content: () => (
      <TutorialPopover
        title="Графік машинозаїздів"
        content="Графік машинозаїздів відображає інформацію стосовно заїзду нових авто по обраному сервісу."
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-cars-chart="step-2"]',
    content: () => (
      <TutorialPopover
        title="Графік машинозаїздів"
        content=" У правому верхньому кутку відображається відсоток нових авто від загальної кількості автомобілів за обраний період"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-cars-chart="step-3"]',
    content: () => (
      <TutorialPopover
        title="Графік машинозаїздів"
        content={
          <>
            При наведенні на сегмент графіка з’являється підказка з інформацією
            про загальну кількість авто та кількість нових машинозаїздів
            <br />
            <br />
            НАВЕДІТЬ НА ГРАФІК ДЛЯ ПЕРЕГЛЯДУ
          </>
        }
      />
    ),
    styles: styles,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-cars-chart="step-4"]',
    content: () => (
      <TutorialPopover
        title="Графік машинозаїздів"
        content=" За замовчуванням графік показує дані за останні 7 днів. Нижче можна змінити початкову та кінцеву дати (окрім майбутніх днів). "
      />
    ),
    styles: styles,
  },
];

export const serviceLoadChartSteps = [
  {
    selector: '[data-tour-load-chart="step-1"]',
    content: () => (
      <TutorialPopover
        title="Графік завантаженості сервісу"
        content="Даний графік відображає погодинну завантаженість сервісу у відсотках відносно кількості активних постів на сервісі за поточний день або дату, обрану у календарі"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-load-chart="step-2"]',
    content: () => (
      <TutorialPopover
        title="Графік завантаженості сервісу"
        content="Завантаженість сервісу у відсотках відносно кількості активних постів"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-load-chart="step-3"]',
    content: () => (
      <TutorialPopover
        title="Графік завантаженості сервісу"
        content={
          <>
            При наведенні курсору на графік і переміщенні вздовж осі X
            з’являється інфо-бокс із кількістю авто на постах в конкретний час
            протягом дня.
            <br />
            <br />
            НАВЕДІТЬ НА ГРАФІК ДЛЯ ПЕРЕГЛЯДУ
          </>
        }
      />
    ),
    styles: styles,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-load-chart="step-4"]',
    content: () => (
      <TutorialPopover
        title="Графік завантаженості сервісу"
        content="Натиснувши на кнопку з зображенням КАЛЕНДАРЯ відкриється календар для вибору необхідної дати"
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-load-chart="step-5"]',
    content: () => (
      <TutorialPopover
        title="Графік завантаженості сервісу"
        content="Оберіть необхідну дату для перегляду"
      />
    ),
    styles: styles,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-load-chart="step-6"]',
    content: () => (
      <TutorialPopover
        title="Графік завантаженості сервісу"
        content="В лівому нижньому куті відображається обрана для перегляду дата"
        skipPart={true}
        currentBackStep={3}
      />
    ),
    styles: styles,
  },
];

export const carsInWorkSteps = [
  {
    selector: '[data-tour-carsinwork="step-1"]',
    content: () => (
      <TutorialPopover
        title="Авто в роботі"
        content="Список 'авто в роботі', показує повний перелік автомобілів, які знаходяться в роботі на сервісі"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-carsinwork="step-2"]',
    content: () => (
      <TutorialPopover
        title="Авто в роботі"
        content="Під назвою секції знаходиться панель керуваня списком"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-carsinwork="step-3"]',
    content: () => (
      <TutorialPopover
        title="Авто в роботі"
        content="Натиснувши на кнопку зі стрілкою можна відсортувати список по даті, або від новіших, або від старіших авто"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-carsinwork="step-4"]',
    content: () => (
      <TutorialPopover
        title="Авто в роботі"
        content="Також можна знайти необхідну машину, ввівши в поле пошуку її номер"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-carsinwork="step-5"]',
    content: () => (
      <TutorialPopover
        title="Авто в роботі"
        content="Є можливість відобразити в списку тільки ті машини, що мають необхідний статус. Для цього оберіть потрібний вам статус в попапі, який з'явиться при кліку на кнопку СТАТУС"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-carsinwork="step-6"]',
    content: () => (
      <TutorialPopover
        title="Авто в роботі"
        content="Клікнувши на кнопку pdf, ви завантажите файл зі списком усіх машин, що знаходяься в роботі на сервісі"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-carsinwork="step-7"]',
    content: () => (
      <TutorialPopover
        title="Авто в роботі"
        content="Також є можливість відкоригувати зовнішній вигляд карток списку, прибравши або додавши пункти в попапі, що з'являється при кліку на кнопку фільтра"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-carsinwork="step-8"]',
    content: () => (
      <TutorialPopover
        title="Авто в роботі"
        content={
          <>
            Сам список представлений картками з інформацією про:
            <br />
            -телефон і ПІБклієнта;
            <br />
            <br />
            -дані авто (VIN, марка, модель, фото, номер, пробіг);
            <br />
            <br />
            -поточний статус обслуговування (нова, діагностика, ремонт,
            завершено);
            <br />
            <br />
            -рейтинг клієнта;
            <br />
            <br />
            -час перебування на посту;
            <br />
            <br />
            -інформацію про аванс та вартість ремонту.
          </>
        }
      />
    ),
    styles: styles,
  },
];

// CRM

export const plannerSteps = [
  {
    selector: '[data-tour-planner="step-1"]',
    content: () => (
      <TutorialPopover
        title="Планувальник"
        content="В нижній частині сторінки “Планувальник” знаходиться блок, що безпосередньо відповідає за планування роботи на автосервісі. Він складається з календаря та таблиці-графіку."
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-planner="step-2"]',
    content: () => (
      <TutorialPopover
        title="Планувальник"
        content="Календар призначений для вибору дати для створення запису на послуги та відображення інформації на графіку."
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-planner="step-3"]',
    content: () => (
      <TutorialPopover
        title="Планувальник"
        content="За замовчуванням в календарі відображається поточна дата, відповідно і інформація в графіку виводиться теж за поточний день. Іншу дату можна обрати клікнувши на відповідну комірку в календарі."
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-planner="step-4"]',
    content: () => (
      <TutorialPopover
        title="Планувальник"
        content="Для зміни місяця використовуйте стрілки біля назви місяця."
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-planner="step-5"]',
    content: () => (
      <TutorialPopover
        title="Планувальник"
        content={
          <>
            Також на календарі відображається завантаженість кожного конкретного
            дня в кольоровому вигляді:
            <br />
            <br />
            Сірий — 0%
            <br />
            <br />
            Темно-помаранчевий — 1–19%
            <br />
            <br />
            Середньо-помаранчевий — 20–39%
            <br />
            <br />
            Помаранчевий — 40–59%
            <br />
            <br />
            Жовто-гарячий — 60–79%
            <br />
            <br />
            Яскраво-червоний — 80% і вище
          </>
        }
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-planner="step-6"]',
    content: () => (
      <TutorialPopover
        title="Планувальник"
        content={
          <>
            На графіку відображається завантаженість постів та механіків по
            годинах на обрану дату та номери автомобілів, які записані на
            послугу.
            <br />
            <br />
            Від обраної послуги залежить колір фону блоку з прізвищем механіка -
            СИНІЙ колір використовується для Діагностики, а ФІОЛЕТОВИЙ - для
            Ремонту.
            <br />
            <br />
            Натиснувши на існуючий запис, можна відредагувати його (якщо час ще
            не минув).
          </>
        }
      />
    ),
    styles: styles,
  },
];

export const periodSelectorSteps = [
  {
    selector: '[data-tour-periodselector="step-1"]',
    content: () => (
      <TutorialPopover
        title="Селектор часового періоду"
        content="На сторінці “Планувальник” в хедері додатку відображається селектор дат."
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-periodselector="step-2"]',
    content: () => (
      <TutorialPopover
        title="Селектор часового періоду"
        content={
          <>
            За замовчуванням інформація на сторінці виводиться за поточний день.
            <br />
            <br />
            Для зміни дати клікніть по іконці календаря і оберіть потрібну дату.
          </>
        }
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-periodselector="step-3"]',
    content: () => (
      <TutorialPopover
        title="Селектор часового періоду"
        content="Дата «По» може бути більшою за поточну для перегляду запланованих візитів, а також робіт та послуг."
      />
    ),
    styles: styles,
  },
];
export const carsListSteps = [
  {
    selector: '[data-tour-carslist="step-1"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content="Таблиця автомобілів на сторінці Планувальник містить хедер зі статусами автомобілів та їх кількістю по кожному конкретному статусу на обрану дату чи за обраний період часу"
      />
    ),
    styles: styles,
  },

  {
    selector: '[data-tour-carslist="step-2"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content="Таблиця автомобілів також містить інформаційні картки по кожному автомобілю.
Щоб змінити статус автомобіля зі статусу «Запис» або «Нова», необхідно створити запис на певну послугу: діагностика або ремонт."
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-carslist="step-3"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content={
          <>
            Кожна картка автомобіля відображає:
            <br />
            <br />
            Інформацію про клієнта : ім’я та номер телефону, його рейтинг
            <br />
            <br />
            Інформацію про автомобіль : фото, номерний знак, марка та модель,
            пробіг, VIN код який можна скопіювати, натиснувши відповідну кнопку
            <br />
            <br />
            Інформація про послугу : назва, вартість, термін перебування в
            роботі, сума передплати за послугу.
          </>
        }
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-carslist="step-3.1"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content="По кліку на кнопку 'ІНФО', що міститься в картці автомобіля, відкривається модальне вікно з інформацією про клієнта та його автомобілі, а також історія обслуговування кожного автомобіля"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-carslist="step-3.2"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content="По кліку на кнопку 'АРХІВУВАТИ АВТО', що міститься в картці автомобіля, відкривається модальне вікно для додавання автомобіля в архів"
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-carslist="step-3.3"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content={
          <>
            В випадаючому селекторі оберіть причину додавання в архів
            <br />
            <br />
            При необхідності додайте коментар
          </>
        }
        disabledBack={true}
      />
    ),
    styles: styles,
  },

  {
    selector: '[data-tour-carslist="step-3.4"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content="Щоб переглянути всі авто додані в архів натисніть на кнопку 'Архів' в верхній частині сайту"
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },

  {
    selector: '[data-tour-carslist="step-3.5"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content="В модальому вікні знаходяться всі автомобілі додані в архів"
        disabledBack={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-carslist="step-3.6"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content="Щоб відновити авто з архіва натисніть на три крапки, що знаходяться в кінці кожного рядочка"
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-carslist="step-3.7"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content="У випадаючому меню оберіть 'ВІДНОВИТИ'"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-carslist="step-3.8"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content="Для виходу з модального вікна архіву натисніть на 'Х' у верхньому правому кутку"
        disabledNext={true}
      />
    ),
    styles: styles,
    // pulse: true,
    stepInteraction: true,
  },

  {
    selector: '[data-tour-carslist="step-4"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content="Інформацію, яка міститься в карточці можна приховувати або відображати натиснувши відповідну кнопку в правому верхньому куті таблиці, поруч із заголовками таблиці, та використовуючи перемикачі."
        skipPart={true}
        currentBackStep={6}
      />
    ),
    styles: styles,
  },
];

export const createRecordSteps = [
  {
    selector: '[data-tour-createrecord="step-1"]',
    content: () => (
      <TutorialPopover
        title="Створення запису"
        content={
          <>
            Створити новий запис можна різними способами:
            <br />
            <br />
            - використовуючи кнопку в хедері додатку (цей спосіб доступний з
            будь-якої сторінки додатку)
            <br />
            <br />
            - за допомогою кнопки “+” в картці авто зі статусом “Нова”
            <br />
            <br />- допомогою кнопки “Створити запис” в Календарі
            {/* <br />
            <br />- натиснувши на вільний слот на графіку. */}
          </>
        }
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-createrecord="step-1"]',
    content: () => (
      <TutorialPopover
        title="Створення запису"
        content="ОБЕРІТЬ БУДЬ-ЯКЙ ВАРІАНТ ТА НАТИСНІТЬ"
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-createrecord="step-2"]',
    content: () => (
      <TutorialPopover
        title="Створення запису"
        content="При використанні будь-якого з вищеперерахованих способів на екрані з’явиться модальне вікно створення запису на поточну дату (в разі використання першого методу з кнопкою в хедері) або на обрану дату в Календарі в разі використання будь-якого з способів на сторінці Планувальник."
        disabledBack={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-createrecord="step-2"]',
    content: () => (
      <TutorialPopover
        title="Створення запису"
        content="При створенні запису обов’язково повинні бути заповнені наступні поля : Номер телефону, Прізвище, ім’я та по-батькові клієнта, дані автомобіля (марка, модель, та номер), послуга та її вид, майстер, пост, механік, дата та час запису 

"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-createrecord="step-2.1"]',
    content: () => (
      <TutorialPopover
        title="Створення запису"
        content="Якщо клієнт вже існує, то можна натиснути на кнопку та обрати необхідного клієнта зі списку вже існуючих"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-createrecord="step-4"]',
    content: () => (
      <TutorialPopover
        title="Створення запису"
        content="Заповнивши всі поля, натисніть 'Зберегти' для додавання запису"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-createrecord="step-5"]',
    content: () => (
      <TutorialPopover
        title="Створення запису"
        content="Для відміни та виходу з модального вікна натисніть 'Закрити'"
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-planner="step-6"]',
    content: () => (
      <TutorialPopover
        title="Створення запису"
        content="Збережений запис відобразиться в планувальнику"
        skipPart={true}
        currentBackStep={0}
      />
    ),
    styles: styles,
  },
];

// InWork

export const generalInfoInWorkSteps = [
  {
    selector: '[data-tour-inworkgi="step-1"]',
    content: () => (
      <TutorialPopover
        title="Загальна інформація про сторінку"
        content="Сторінка “В роботі” призначена для відображення всіх автомобілів, що перебувають або перебували у процесі виконання робіт, за певний період."
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkgi="step-2"]',
    content: () => (
      <TutorialPopover
        title="Панель керування сторінкою"
        content="На панелі керування сторінкою можна обрати часовий період, відфільтрувати авто по статусу, завантажити пдф-документ та налаштувати зовнішній вигляд карток."
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkgi="step-3"]',
    content: () => (
      <TutorialPopover
        title="Панель керування сторінкою"
        content="В лівій частині панелі керування можна обрати фіксований період відображення автомобілів (за день, тиждень, місяць чи за весь час) "
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkgi="step-4"]',
    content: () => (
      <TutorialPopover
        title="Панель керування сторінкою"
        content="Також можна обрати необхідний довільний період, обравши початкову та кінцеву дати.За замовчуванням відображається список автомобілів у роботі за тиждень."
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkgi="step-5"]',
    content: () => (
      <TutorialPopover
        title="Панель керування сторінкою"
        content="По середині панелі керування знаходиться селектор для фільтрації автомобілів по статусам."
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-inworkgi="step-6"]',
    content: () => (
      <TutorialPopover
        title="Панель керування сторінкою"
        content={
          <>
            - Нові - ті автомобілі, що тільки заїхали на сервіс
            <br />
            <br />
            - Діагностика - автомобілі, що знаходяться на етапі діагностики або
            записані безпосередньо на цю послугу
            <br />
            <br />
            - Ремонт - автомобілі, які знаходяться на етапі ремонту (пройшло
            діагностику, мають сформовану і затверджену КП)
            <br />
            <br />- Завершено - автомобілі, у яких завершений ремонт всіх
            запчастин та виконані всі послуги
          </>
        }
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkgi="step-7"]',
    content: () => (
      <TutorialPopover
        title="Панель керування сторінкою"
        content="Для створення та завантаження PDF-документу зі списком автомобілів у роботі, натисніть на кнопку '.pdf'"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkgi="step-8"]',
    content: () => (
      <TutorialPopover
        title="Панель керування сторінкою"
        content="Натисніть на кнопку фільтрації для редагування вигляду списку авто та трекера виконаних робіт автомобіля. Для цього необхідно натиснути на відповідну кнопку і у випадаючому списку залишити увімкненими лише ті категорії, які вам потрібні."
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkgi="step-9"]',
    content: () => (
      <TutorialPopover
        title="Статистика"
        content="Панель зі статистикою відображає статистичні дані за обраний період, пов’язані з автомобілями, що знаходяться (або ж знаходились) в роботі.

Кожен круговий прогресбар відповідає за певний статистичний параметр та відображає інформацію в кількісному параметрі над прогресбаром (шт.) та у відсотковому відносно до параметру “Всього”"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkgi="step-10"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content={
          <>
            Під статистикою на сторінці “В роботі” знаходиться список
            автомобілів в роботі.
            <br />
            <br />
            По кожному автомобілю відображається інформація про сам автомобіль,
            дату прибуття авто, статус та етап роботи, на якому він знаходиться
            в даний момент, а також роботи, які вже були проведені з цим
            автомобілем.
            <br />
            <br />
            Виконані роботи мають індикацію про успішне завершення - зелений фон
            у іконки на відповідному етапі.
          </>
        }
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkgi="step-11"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content="В панелі керування списком є можливість відсортувати список за необхідним параметром за зростанням або за спаданням."
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkgi="step-12"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content="Сортування за датою: спочатку новіші або навпаки"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkgi="step-13"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content="Пошук необхідного авто, що відбувається за номером авто або назвою, або за ім'ям клієнта"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkgi="step-14"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content="Сортування за наявністю звернення: спочатку ті авто, у яких є звернення або навпаки"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkgi="step-15"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content="Сортування за наявністю діагностики: спочатку ті авто, у яких проведена діагностика або навпаки"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkgi="step-16"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content="Сортування за наявністю КП: спочатку ті авто, у яких сформоване КП або навпаки"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkgi="step-17"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content="Сортування за наявністю Авансу: спочатку ті авто, у по яким проведено Аванс або навпаки"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkgi="step-18"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content="Сортування за наявністю Замовлення по запчастинам: спочатку ті авто, у яких запчастини для ремонту вже замовлені або навпаки"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkgi="step-19"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content="Сортування за наявністю Отриманих запчастин: спочатку ті авто, у яких всі запчастини отримані або навпаки"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkgi="step-20"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content="Сортування за наявністю Ремонту: спочатку ті авто, у яких ремонт завершено або навпаки"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkgi="step-21"]',
    content: () => (
      <TutorialPopover
        title="Список авто"
        content="Сортування за наявністю Оплати: спочатку ті авто, у яких оплата здійснена в повному розмірі або навпаки"
      />
    ),
    styles: styles,
  },
];

export const diagnosticPartSteps = [
  {
    selector: '[data-tour-inwork="stepDiag-1"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="При кліку на кнопку “Діагностика” відкривається модальне вікно для створення діагностики автомобіля."
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    pulse: true,
  },
  {
    selector: '[data-tour-inworkdiag="step-2"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="Дане модальне вікно призначене для внесення результатів проведеної механіком діагностики, а також для створення списку запчастин, що за результатами діагностики, потребують заміни."
        disabledBack={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkdiag="step-3"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="Для початку створення діагностики необхідно додати всі дані, яких не вистачає. По центру модального вікна висвітиться підказка, чого саме не вистачає."
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkdiag="step-3.1"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="Обов'язковими даними для початку проведення діагностики є пробіг, він-код автомобіля, ім’я та прізвище власника, а також його номер телефону."
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkdiag="step-3.2"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="Натиснувши іконку з зображенням олівця, що знаходиться в полі VIN-коду, можна відредагувати VIN-код автомобіля"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkdiag="step-3.3"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="Натиснувши іконку з зображенням олівця, що знаходиться в полі пробігу, можна відредагувати поробіг автомобіля"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkdiag="step-4"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="Обов'язково оберіть механіка, це необхідно для проведення діагностики"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkdiag="step-4.1"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="Клікніть на селектор, щоб відкрити список всіх доступних механіків"
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    pulse: true,
  },
  {
    selector: '[data-tour-inworkdiag="step-4.2"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="ОБЕРІТЬ МЕХАНІКА"
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-inworkdiag="step-5"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="Після додавання усієї необхідної інформації стане доступним функціонал створення діагностики."
      />
    ),
    styles: styles,
    // stepInteraction: true,
  },
  {
    selector: '[data-tour-inworkdiag="step-5.1"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="Якщо попередньо діагностика була проведена механіком, ця інформація з'явиться в колонці ліворуч"
      />
    ),
    styles: styles,
    // stepInteraction: true,
  },
  {
    selector: '[data-tour-inworkdiag="step-5.2"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="Запчастини, що ви вже додали до діагностики, можна для зручності відмітити чекбоксом."
      />
    ),
    styles: styles,
    // stepInteraction: true,
  },
  {
    selector: '[data-tour-inworkdiag="step-6"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="В першій колонці знаходиться дерево категорій та підкатегорій запчастин. "
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkdiag="step-6"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="Розкрийте катерогію та у списку з'явившихся підкатегорій оберіть необхідну запчастину."
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-inworkdiag="step-7"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content={
          <>
            Після кліку по підкатегорії почнеться пошук всіх можливих запчастин
            для конкретної машини.Вони відобразяться в табличці з правої сторони
            екрану.
            <br />
            <br />У таблиці наведено повну інформацію про запчастини, а також
            схему, яку можна збільшити, натиснувши на неї.
          </>
        }
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkdiag="step-8"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="Щоб обрати запчастину натисніть на чекбокс"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkdiag="step-7"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="Оберіть необхідні запчастини та натисніть 'Далі'"
      />
    ),
    styles: styles,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-inworkdiag="step-10"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="Список обраних запчастин можна переглянути клікнувши на кнопку"
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-inworkdiag="step-10.1"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="Якщо запчастину додано помилково, її можна видалити, клікнувши на іконку з зображенням смітника"
        disabledBack={true}
      />
    ),
    styles: styles,
    // pulse: true,
    // stepInteraction: true,
  },
  {
    selector: '[data-tour-inworkdiag="step-10.2"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="Натисніть на іконку з зображенням 'Х' для виходу з модального вікна."
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-inworkdiag="step-11"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="У випадку якщо з автомобілем все добре, позначте 'Проблем не виявлено' (З'являється лише у випадку відсутності діагностики проведеної механіком)."
        skipPart={true}
        currentBackStep={17}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkdiag="step-12"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="Для переходу до чорнового варіанту натисніть Зберегти"
        disabledNext={true}
      />
    ),
    styles: styles,
    pulse: true,
    stepInteraction: true,
  },
  {
    selector: '[data-tour-inworkdiag="step-13"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="В чорновому варіанті документу знаходиться траблиця остаточно обраних запчастин. Також, якщо діагностика була створена механіком через Додаток Механіка, можна перегляути фото поломок або коментар механіка, який він додав під час проведення діагностики."
        disabledBack={true}
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkdiag="step-14"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="У випадку якихось неточностей стосовно обраних запчастин, ви завжди можете повернутись на попередній екран, натиснувши кнопку 'Скасувати', щоб внести корективи."
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkdiag="step-15"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="Для остаточного збереження діагностики та подальшого створення комерційної пропозиції, натисніть кнопку 'Зберегти'"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inwork="stepDiag-16"]',
    content: () => (
      <TutorialPopover
        title="Створення діагностики"
        content="Зелений колір індикатора на кнопці свідчить про те, що діагностика вже створена, клікнувши на таку кнопку ви зможете перегглянути готову діагностику."
      />
    ),
    styles: styles,
  },
];

export const appointmentSteps = [
  {
    selector: '[data-tour-inwork="stepAppointment-1"]',
    content: () => (
      <TutorialPopover
        title="Запис"
        content="При кліку на кнопку 'Запис' відкривається інформаційне модальне вікно про запис клієнта."
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepAppointment-2"]',
    content: () => (
      <TutorialPopover
        title="Запис"
        content="В модальному вікні присутня інформація про клієнта та його автомобіль"
        disabledBack={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepAppointment-3"]',
    content: () => (
      <TutorialPopover
        title="Запис"
        content="Також присутня інформація про деталі запису, такі як: послуга, вид послуги, час звернення, час запису, механік та пост, на який записано клієнта."
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepAppointment-4"]',
    content: () => (
      <TutorialPopover
        title="Запис"
        content="Для виходу з модального вікна натисніть 'Х'."
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepAppointment-5"]',
    content: () => (
      <TutorialPopover
        title="Запис"
        content="Інформація про запис присутня лише тоді, коли він був створений до візиту на сервіс. Про його наявність свідчить колір індикатору на кнопці, якщо індикатор зелений, то запис наявний, якщо сірий - то попереднього запису не було."
        skipPart={true}
        currentBackStep={0}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
];

export const commercialOfferSteps = [
  {
    selector: '[data-tour-inwork="stepCO-1"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content="При кліку на кнопку 'КП' відкривається модальне вікно для створення комерційної пропозиції."
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepCO-2"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content="Модальне вікно КП за замовчуванням має наступний вигляд"
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepAppointment-2"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content="КП, яка створюється без проходження діагностики, може містити або не містити дані про авто або клієнта."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepCO-4"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content="Якщо дані про клієнта відсутні, то створіть його натиснувши на кнопку з зображенням плюса, або оберіть з вже існуючих натиснувши на сусідню кнопку. "
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },

  {
    selector: '[data-tour-inworkdiag="step-3.2"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content="Натиснувши іконку з зображенням олівця, що знаходиться в полі VIN-коду, можна відредагувати VIN-код автомобіля"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inworkdiag="step-3.3"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content="Натиснувши іконку з зображенням олівця, що знаходиться в полі пробігу, можна відредагувати поробіг автомобіля"
      />
    ),
    styles: styles,
  },
  {
    selector: '[data-tour-inwork="stepCO-5"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content="Верхня частина КП має містити інформацію про запропоновані клієнту запчастини. Поля, обов’язкові для заповнення («Кількість», «Номенклатура», «Ціна закупівлі», «Ціна продажу»), позначені червоним. "
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },

  {
    selector: '[data-tour-inwork="stepCO-5"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content={
          <>
            «Сума продажу», «Сума закупівлі», «Сума робіт» та «%» (відсоток
            націнки) обчислюються автоматично під час внесення або зміни даних у
            полях «Кількість», «Ціна продажу», «Ціна закупівлі» та «Ціна робіт».
            <br />
            <br />
            Значення поля «%» можна змінити вручну. У такому разі автоматично
            буде перераховано «Ціну продажу», «Суму продажу» та «Прибуток».
          </>
        }
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepCO-5"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content="Додайте дані у всі обов'язкові поля та натисніть Далі"
        // disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepCO-8"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content="Після внесення всіх необхідних даних у рядок для збереження інформації обов’язково натисніть на кнопку для збереження даних,  інакше введені дані буде втрачено."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  // {
  //   selector: '[data-tour-inwork="stepCO-9"]',
  //   content: () => (
  //     <TutorialPopover
  //       title="Комерційна пропозиція"
  //       content="Дані у створеному рядку можна відредагувати, натиснувши кнопку редагування."
  //       // disabledNext={true}
  //       // skipPart={true}
  //       // currentBackStep={8}
  //       // disabledBack={true}
  //     />
  //   ),
  //   styles: styles,
  //   // stepInteraction: true,
  //   // pulse: true,
  // },
  {
    selector: '[data-tour-inwork="stepCO-10"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content="Для того, щоб видалити рядок (у випадку якщо клієнту не пропонуються ніякі запчастини, а лише послуги), натисніть кнопку з зображенням мінуса. Відновити видалений рядок неможливо!"
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },

  {
    selector: '[data-tour-inwork="stepCO-11"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content="Кнопка “+” під списком запчастин призначена для додавання рядка, тобто нової запчастини."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepCO-12"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content="Натисніть кнопку 'ДОДАТИ ЗІ СКЛАДУ', щоб додати запчастини наявні на складі."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepCO-13"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content="У цій же частині КП можна побачити загальну ціну продажу, суму продажу, прибуток та суму робіт за запропонованими клієнту запчастинами."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },

  {
    selector: '[data-tour-inwork="stepCO-14"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content="Для внесення інформації про запропоновані клієнту послуги використовується нижня частина КП"
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepCO-15"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content="Залежно від того, як розраховуються ціни на послуги, треба обрати «Фіксований прайс» чи «Нормогодини». Обране налаштування буде застосоване до всіх доданих послуг."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepCO-16"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content="Після вибору способу розрахунку натисніть «Обрати послугу». Оберіть необхідні послуги зі списку."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepCO-17"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content="У нижній частині КП можна побачити «Загальну суму КП», яка складається із «Суми продажу», «Суми робіт» та «Вартості послуг»"
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepCO-18"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content="Також, для створення КП обов'язово оберіть час проведення ремонту"
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepCO-19"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content="Для збереження КП та відправлення документа на затвердження клієнту натисніть кнопку 'Зберегти'"
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepCO-21"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content="Після збереження КП, її необхідно відправити клієнту на погодження, а всі подальші зміни можна відслідковувати та робити у виділеном блоці - так званому 'трекері КП'."
        // disabledNext={true}
        // skipPart={true}
        // currentBackStep={0}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepCO-20"]',
    content: () => (
      <TutorialPopover
        title="Комерційна пропозиція"
        content="Сформована КП відправляється на затвердження клієнту. Після того, як КП стає підтвердженим, індикатор стає зеленого кольору та відкриваються до заповнення наступні документи."
        // disabledNext={true}
        skipPart={true}
        currentBackStep={0}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
];

export const paymentModalsSteps = [
  {
    selector: '[data-tour-inwork="stepPM-1"]',
    content: () => (
      <TutorialPopover
        title="Аванс"
        content="При кліку на кнопку 'Аванс' відкривається модальне вікно для внесення повної або часткової оплати від клієнта."
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepPM-2"]',
    content: () => (
      <TutorialPopover
        title="Аванс"
        content="Модальне вікно 'Аванс' виглядає наступним чином."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepPM-3"]',
    content: () => (
      <TutorialPopover
        title="Аванс"
        content="Для внесення оплати необхідно обрати у випадаючому меню юридичну особу та назву каси, на які будуть зараховані кошти.

."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepPM-4"]',
    content: () => (
      <TutorialPopover
        title="Аванс"
        content="Потім зазначте суму у відповідному полі. Для початку введення треба натиснути на олівець."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepPM-5"]',
    content: () => (
      <TutorialPopover
        title="Аванс"
        content="У полі “Ремонт” зазначається повна сума запропонованих робіт (запчастини та їх заміна, а також додаткові послуги). Саме ця сума є загальною сумою КП."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepPM-6"]',
    content: () => (
      <TutorialPopover
        title="Аванс"
        content="У полі “Залишок” зазначена суму якої не вистачає до повного розрахунку клієнтом."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepPM-7"]',
    content: () => (
      <TutorialPopover
        title="Аванс"
        content="У полі “Аванс” відображена сума всіх внесених коштів до цього моменту."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepPM-8"]',
    content: () => (
      <TutorialPopover
        title="Аванс"
        content="Для перевірки правильності інформації зазначеної в даному модальному вікні можна перейти до модального вікна КП (Комерційної пропозиції), для цього треба клікнути по посиланню з номером комерційної пропозиції в правому верхньому куті."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepPM-9"]',
    content: () => (
      <TutorialPopover
        title="Аванс"
        content="Для збереження оплати натисніть кнопку “Внести” в правому нижньому куті."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepPM-10"]',
    content: () => (
      <TutorialPopover
        title="Аванс"
        content="Також, при необхідності, після проведення оплати можна сформувати та завантажити PDF-документ з інформацією про оплату. Для цього необхідно натиснути кнопку pdf."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepPM-11"]',
    content: () => (
      <TutorialPopover
        title="Аванс"
        content="Після внесення суми (частини) індикатор авансу стає зеленим."
        // disabledNext={true}
        skipPart={true}
        currentBackStep={0}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
];

export const incomeModalSteps = [
  {
    selector: '[data-tour-inwork="stepIM-1"]',
    content: () => (
      <TutorialPopover
        title="Оплата клієнта"
        content="При кліку на кнопку оплати відкривається модальне вікно оплати клієнта."
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepPM-2"]',
    content: () => (
      <TutorialPopover
        title="Оплата клієнта"
        content="Модальне вікно оплати клієнта виглядає ідентично, як і інші модальні вікна проведення оплат, і відповідно внесення оплати працює аналогічно."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepPM-3"]',
    content: () => (
      <TutorialPopover
        title="Оплата клієнта"
        content="Для внесення оплати необхідно обрати у випадаючому меню юридичну особу та назву каси, на які будуть зараховані кошти.

."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepPM-4"]',
    content: () => (
      <TutorialPopover
        title="Оплата клієнта"
        content="Потім зазначте суму у відповідному полі. Для початку введення треба натиснути на олівець."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepPM-5"]',
    content: () => (
      <TutorialPopover
        title="Оплата клієнта"
        content="У полі “Ремонт” зазначається повна сума запропонованих робіт (запчастини та їх заміна, а також додаткові послуги). Саме ця сума є загальною сумою КП."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepPM-6"]',
    content: () => (
      <TutorialPopover
        title="Оплата клієнта"
        content="У полі “Залишок” зазначена суму якої не вистачає до повного розрахунку клієнтом."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepPM-7"]',
    content: () => (
      <TutorialPopover
        title="Оплата клієнта"
        content="У полі “Аванс” відображена сума всіх внесених коштів."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepPM-8"]',
    content: () => (
      <TutorialPopover
        title="Оплата клієнта"
        content="Для перевірки правильності інформації зазначеної в даному модальному вікні можна перейти до модального вікна КП (Комерційної пропозиції), для цього треба клікнути по посиланню з номером комерційної пропозиції в правому верхньому куті."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },

  {
    selector: '[data-tour-inwork="stepPM-9"]',
    content: () => (
      <TutorialPopover
        title="Оплата клієнта"
        content="Для збереження оплати натисніть кнопку “Внести” в правому нижньому куті."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepPM-10"]',
    content: () => (
      <TutorialPopover
        title="Оплата клієнта"
        content="Також, при необхідності, можна сформувати та завантажити PDF-документ з інформацією про оплату. Для цього необхідно натиснути кнопку pdf."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepIM-11"]',
    content: () => (
      <TutorialPopover
        title="Оплата клієнта"
        content="У випадку якщо сума за ремонт внесена повністю індикатор оплати стає зеленими."
        // disabledNext={true}
        skipPart={true}
        currentBackStep={0}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
];

export const clientInfoModalSteps = [
  {
    selector: '[data-tour-inwork="stepClientInfo-1"]',
    content: () => (
      <TutorialPopover
        title="Інформація по клієнту"
        content="При кліку на інформаційну картку авто на початку рядка, відкривається модальне вікно з даними про клієнта, його автомобілями та історією обслуговування кожного автомобіля."
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-2"]',
    content: () => (
      <TutorialPopover
        title="Інформація по клієнту"
        content={
          <>
            Модальне вікно клієнта призначене для відображення повної інформації
            про користувача в одному місці.
            <br />
            <br />
            У ньому зібрані:
            <br />
            - основні персональні дані клієнта (ім’я, контактна інформація,
            рейтинг та ін.)
            <br />
            - перелік усіх його зареєстрованих автомобілів
            <br />- детальна історія обслуговування кожного автомобіля на
            сервісах, що підключені до CRMMech.
          </>
        }
        // disabledNext={true}
        disabledBack={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-3"]',
    content: () => (
      <TutorialPopover
        title="Інформація по клієнту"
        content="Ліву половину Модального вікна клієнта займає детальна інформація безпосередньо про клієнта, а також його “автопарк” (всі автомобілі додані до клієнта)."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-4"]',
    content: () => (
      <TutorialPopover
        title="Інформація по клієнту"
        content="В верхній частині Інформації про клієнта та автомобіль ви можете знайти всю детальну інформацію про клієнта: фото, ім’я, дату народження, рейтинг та статистику витрачених коштів на послуги."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-5"]',
    content: () => (
      <TutorialPopover
        title="Інформація по клієнту"
        content="Для редагування інформації по клієнту, натисніть на кнопку з зображенням олівця."
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-6"]',
    content: () => (
      <TutorialPopover
        title="Інформація по клієнту"
        content="В модальному вікні, що з'явиться, відредагуйте необхідні дані та натисніть 'Зберегти' "
        // disabledNext={true}
        disabledBack={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-6.1"]',
    content: () => (
      <TutorialPopover
        title="Інформація по клієнту"
        content="Натисніть 'Скасувати' для виходу з модального вікна "
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-7"]',
    content: () => (
      <TutorialPopover
        title="Інформація по клієнту"
        content="Трохи нижче представлений блок контактної інформації клієнта."
        // disabledNext={true}
        skipPart={true}
        currentBackStep={4}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-7"]',
    content: () => (
      <TutorialPopover
        title="Інформація по клієнту"
        content={
          <>
            Для того, щоб зв’язатись з клієнтом можна скористатись одним з
            перерахованих способів, наприклад:
            <br />
            <br />
            - подзвонити, клікнувши на кнопку з зображенням телефону;
            <br />
            - написати електронний лист, натиснувши на відповідну кнопку з
            зображенням “собачки”;
            <br />- зв’язатись за допомогою месенджеру, якщо ця контактна
            інформація вказана. За замовчуванням - це Telegram.
          </>
        }
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-8"]',
    content: () => (
      <TutorialPopover
        title="Інформація по клієнту"
        content="Також, при необхідності, можна скопіювати адресу електронної пошти. "
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-9"]',
    content: () => (
      <TutorialPopover
        title="Інформація по клієнту"
        content="В нижній частині Інформації про клієнта та автомобіль представлена інформація пов’язана з автомобілями клієнта у вигляді карток для кожного автомобіля."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-10"]',
    content: () => (
      <TutorialPopover
        title="Інформація по клієнту"
        content="Кожна картка містить фото, марку та модель авто, рік випуску, він-код та номерний знак авто. Також може містити фото або скан-копію тех.паспорта автомобіля."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-11"]',
    content: () => (
      <TutorialPopover
        title="Інформація по клієнту"
        content="Для того, щоб додати нове авто необхідно натиснути кнопку, що знаходиться в правому нижньому куті, після чого відкриється модальне вікно для додавання авто. "
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-12"]',
    content: () => (
      <TutorialPopover
        title="Інформація по клієнту"
        content="Всі поля, що є обов’язковими до заповнення, позначені зірочкою (*): номерний знак, марка та модель автомобіля, рік випуску. "
        // disabledNext={true}
        disabledBack={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-13"]',
    content: () => (
      <TutorialPopover
        title="Інформація по клієнту"
        content="Після внесення всіх необхідних даних натисніть 'Зберегти' для збереження автомбіля"
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-6.1"]',
    content: () => (
      <TutorialPopover
        title="Інформація по клієнту"
        content="Натисніть 'Закрити' для скасування та виходу з модального вікна. "
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-15"]',
    content: () => (
      <TutorialPopover
        title="Інформація по клієнту"
        content="Для редагування даних автомобіля необхідно натиснути на іконку олівця на картці автомобіля. Відкриється модальне вікно аналогічне тому, яке відкривається при створенні авто, в якому можна відредагувати необхідні дані. "
        // disabledNext={true}
        skipPart={true}
        currentBackStep={12}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-16"]',
    content: () => (
      <TutorialPopover
        title="Інформація по клієнту"
        content="Для видалення автомобілю повністю натисніть на іконку смітника, яка знаходиться в правому верхньому кутку. "
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-17"]',
    content: () => (
      <TutorialPopover
        title="Історія обслуговування"
        content={
          <>
            В правій частині Модального вікна клієнта знаходиться інформація про
            історію обслуговування обраного автомобіля.
            <br />
            <br />
            Клікнувши по картці автомобіля з “автопарку” клієнта в лівій частині
            можна перемикнути історію обслуговування на відповідний автомобіль.
          </>
        }
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-18"]',
    content: () => (
      <TutorialPopover
        title="Історія обслуговування"
        content="В заголовку історії обслуговування знаходиться інформація про марку та модель автомобіля. А також пошук, за допомогою якого можна знайти саме той запис в історії обслуговування, що містить необхідну запчастину. "
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-19"]',
    content: () => (
      <TutorialPopover
        title="Історія обслуговування"
        content="Сама історія обслуговування складається з загальної інформації про заїзд, проведених робіт з автомобілем і детальної інформації по кожній з проведених робіт."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-20"]',
    content: () => (
      <TutorialPopover
        title="Історія обслуговування"
        content="В частині з загальною інформацією відображається пробіг автомобіля на момент заїзду на сервіс."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-21"]',
    content: () => (
      <TutorialPopover
        title="Історія обслуговування"
        content="Також тут знаходиться сума сплачених коштів. "
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-22"]',
    content: () => (
      <TutorialPopover
        title="Історія обслуговування"
        content="Та інформація про дату та час заїзду. "
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-23"]',
    content: () => (
      <TutorialPopover
        title="Історія обслуговування"
        content="В частині інформації про проведені роботи з автомобілем при кліку на кнопку з зеленим індикатором відкриється детальна інформація щодо цього пункту. "
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-24"]',
    content: () => (
      <TutorialPopover
        title="Історія обслуговування"
        content="У вкладці «Звернення» відображається інформація про першочергове звернення клієнта на сервіс."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-25"]',
    content: () => (
      <TutorialPopover
        title="Історія обслуговування"
        content="У вкладці «Діагностика» міститься інформація про проведену діагностику автомобіля. Вона поділена на додаткові розділи: запчастини, фото поломок та коментар механіка."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-26"]',
    content: () => (
      <TutorialPopover
        title="Історія обслуговування"
        content="У розділі «КП» зібрана інформація про комерційну пропозицію для клієнта. "
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-27"]',
    content: () => (
      <TutorialPopover
        title="Історія обслуговування"
        content="У розділі «Ремонт» зібрана інформація про виконаний ремонт: перелік робіт і їхня вартість, а також ціна запчастин."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepClientInfo-28"]',
    content: () => (
      <TutorialPopover
        title="Історія обслуговування"
        content="У вкладці “Рекомендації” виводиться рекомендація механіка за результатами ремонту та для подальшого обслуговування автомобіля. "
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
];

export const orderSteps = [
  {
    selector: '[data-tour-inwork="stepOrder-1"]',
    content: () => (
      <TutorialPopover
        title="Замовлення"
        content="Після створення комерційної пропозиції з'являється можливість створити замовлення по необхідним запчастинам у постачальника."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepOrder-2"]',
    content: () => (
      <TutorialPopover
        title="Замовлення"
        content="Для створення замовлення натисніть на кнопку з іконкою стрілки."
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepOrder-3"]',
    content: () => (
      <TutorialPopover
        title="Замовлення"
        content={
          <>
            У випадаючому меню, що з'явиться, оберіть необхідну накладну. Кожна
            накладна - це замовлення у конкретного постачальника назва якого
            вказується в номері накладної.
            <br />
            <br />
            Оберіть першу накладну.
          </>
        }
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepOrder-4"]',
    content: () => (
      <TutorialPopover
        title="Замовлення"
        content="Замовлення може бути сформоване тільки на основі створеної Комерційної пропозиції, яку погодив клієнт."
        // disabledNext={true}
        disabledBack={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepOrder-5"]',
    content: () => (
      <TutorialPopover
        title="Замовлення"
        content="У Замовленні є інформація про авто, ім’я та контактні дані клієнта."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepOrder-6"]',
    content: () => (
      <TutorialPopover
        title="Замовлення"
        content="По кліку на посилання з номером комерційної пропозиції, можна одразу перейти і переглянути інформацію по КП, на основі якої створюється Замовлення."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepOrder-7"]',
    content: () => (
      <TutorialPopover
        title="Замовлення"
        content="У документі міститься назва постачальника, у якого буде оформлюватися замовлення."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepOrder-8"]',
    content: () => (
      <TutorialPopover
        title="Замовлення"
        content=" Загальна сума замовлення по кожному постачальнику."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepOrder-9"]',
    content: () => (
      <TutorialPopover
        title="Замовлення"
        content=" А також інформація по товару, що замовляється."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepOrder-10"]',
    content: () => (
      <TutorialPopover
        title="Замовлення"
        content=" По кліку на кнопку “Сайт”, вас перенаправить на сайт постачальника, де можна зробити замовлення безпосередньо за допомогою “кошика”, якщо постачальник надає таку можливість."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepOrder-11"]',
    content: () => (
      <TutorialPopover
        title="Замовлення"
        content="Замовлення можна завантажити у форматі PDF по кліку на кнопку “pdf” біля кнопок скасування і оформлення замовлення."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepOrder-12"]',
    content: () => (
      <TutorialPopover
        title="Замовлення"
        content="Після перевірки всіх даних можна оформлювати замовлення. Кнопка “Замовити” оформлює та зберігає замовлення, а “Скасувати” - відміняє його і закриває модальне вікно."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepOrder-13"]',
    content: () => (
      <TutorialPopover
        title="Замовлення"
        content="Після того як всі необхідні запчастини будуть замовлені індикатор стане зеленого кольору."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
];

export const receivedSteps = [
  {
    selector: '[data-tour-inwork="stepReceived-1"]',
    content: () => (
      <TutorialPopover
        title="Надходження"
        content="Після створення замовлення стає доступним перегляд модального вікна “Надходження товару”."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepReceived-2"]',
    content: () => (
      <TutorialPopover
        title="Надходження"
        content="Щоб переглянути надходження натисніть на кнопку з іконкою стрілки."
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepReceived-3"]',
    content: () => (
      <TutorialPopover
        title="Надходження"
        content={
          <>
            У випадаючому меню, що з'явиться, оберіть необхідну накладну. Кожна
            накладна надходження відповідає конкретному замовленню у конкретного
            постачальника.
            <br />
            <br />
            Оберіть першу накладну.
          </>
        }
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepReceived-4"]',
    content: () => (
      <TutorialPopover
        title="Надходження"
        content="Модальне вікно “Надходження товару” необхідне для того, щоб була змога відслідковувати, які саме запчастини надійшли, а також змінювати статус надходження запчастин."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepReceived-5"]',
    content: () => (
      <TutorialPopover
        title="Надходження"
        content="У Надходженні є інформація про авто, ім’я та контактні дані клієнта."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepReceived-6"]',
    content: () => (
      <TutorialPopover
        title="Надходження"
        content="Щоб переглянути все замовлення в комплексі, можна перейти в модальне вікно “Замовлення”, натиснувши на посилання вгорі."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepReceived-7"]',
    content: () => (
      <TutorialPopover
        title="Надходження"
        content="Трохи нижче розташована назва постачальника, у якого було сформовано замовлення."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepReceived-8"]',
    content: () => (
      <TutorialPopover
        title="Надходження"
        content="Під назвою постачальника знаходиться таблиця з усіма замовленими запчастинами."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepReceived-9"]',
    content: () => (
      <TutorialPopover
        title="Надходження"
        content="Для зміни статусу запчастин, що надійшли, необхідно поставити галочку в чекбоксі, клікнувши на нього."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },

  {
    selector: '[data-tour-inwork="stepReceived-10"]',
    content: () => (
      <TutorialPopover
        title="Надходження"
        content="По кліку на кнопку сплатити постачальнику відкривається модальне вікно для оплати постачальнику за замовлені та поставлені запчастини."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepReceived-11"]',
    content: () => (
      <TutorialPopover
        title="Надходження"
        content=" В полі “Сума” відображається загальна сума всього замовлення."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepReceived-12"]',
    content: () => (
      <TutorialPopover
        title="Надходження"
        content=" В полі “Аванс” відображається сплачена постачальнику сума."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepReceived-13"]',
    content: () => (
      <TutorialPopover
        title="Надходження"
        content=" В полі “Борг” відображається залишок, що треба оплатити за замовлені запчастини."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },

  {
    selector: '[data-tour-inwork="stepReceived-14"]',
    content: () => (
      <TutorialPopover
        title="Надходження"
        content="Надходження можна завантажити у форматі PDF по кліку на кнопку “pdf”."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },

  {
    selector: '[data-tour-inwork="stepReceived-15"]',
    content: () => (
      <TutorialPopover
        title="Надходження"
        content="Після внесення змін в статуси надходження запчастин, натисніть кнопку “Отримано”. Це оновить список накладних на сторінці “В роботі”."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },

  {
    selector: '[data-tour-inwork="stepReceived-16"]',
    content: () => (
      <TutorialPopover
        title="Надходження"
        content="Після того, як всі запчастини по всім накладним із замовлення будуть отриманні, індикатор в кнопці “Отримано” для відповідного автомобіля стане зеленого кольору - це індикація повністю виконаного і доставленого замовлення."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
];

export const repairSteps = [
  {
    selector: '[data-tour-inwork="stepRepair-1"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content="Після того, як для клієнта була сформована комерційна пропозиція, з’являється можливість відкрити модальне вікно з документом “Ремонту” по кліку на кнопку 'Ремонт'."
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepRepair-2"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content="В модальному вікні представлена вся інформація пов'язана з ремонтом і обслуговуванням автомобіля."
        // disabledNext={true}
        disabledBack={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inworkrepair="step-3"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content="В модальному вікні виводиться інформація про клієнта та його авто."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepRepair-4"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content="Також тут знаходиться перелік запчастин, потрібних для ремонту та обслуговування, і послуг, які виконуються по даному авто."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepRepair-5"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content={
          <>
            Таблиця ремонту містить:
            <br />
            <br />
            - загальні дані по запчастинах (виробник, код, артикул, ціна);
            <br />
            - ціни на запчастини та розрахунок чистого прибутку;
            <br />- ім’я механіка, який виконує роботу по заміні чи ремонту
            певної запчастини, а також % і суму, яку отримає механік за виконану
            роботу.
          </>
        }
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepRepair-6"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content="Якщо таблиця запчастин порожня, за потреби можна додати їх вручну, натиснувши на зелену кнопку “+” ."
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepRepair-7"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content="Для коректної роботи та звітності, а також нарахування зарплатні механіку та менеджеру, слід заповнити всі поля по запчастині та цінам, обрати механіка, та натиснути кнопку з іконкою дискети."
        // disabledBack={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepRepair-7"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content="Заповніть поля та натисніть Далі"
        // disabledBack={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepRepair-7.1"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content="Натисніть дискету, щоб зберегти рядок"
        // disabledBack={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepRepair-8"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content="Усі запчастини, надходження яких підтверджено у накладній Надходження товару на сторінці “В роботі”, автоматично змінюють статус на «наявні» (зелена іконка з галочкою). Якщо ж запчастина ще не була доставлена, то світиться червона іконка з хрестиком."
        // disabledNext={true}
        skipPart={true}
        currentBackStep={5}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepRepair-9"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content="Також статус надходження можна змінювати вручну: клікніть на іконку олівця в колонці Наявність → поставте галочку в чекбоксі → натисніть іконку дискети, щоб «Зберегти» зміну статусу."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepRepair-10"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content="Якщо ремонт по одній запчастині виконаний, у таблиці потрібно встановити чекбокс, та зберегти зміни."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepRepair-11"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content="Для збереження треба натиснути кнопку 'Зберегти зміни'. Коли всі запчастини “готові”, замість кнопки №10 «Зберегти зміни» з’явиться кнопка «Готово». Переведення ремонту у статус «Готово» необхідне для можливості завершення всього ремонту авто."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepRepair-12"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content="У нижній частині модального вікна відображається список наданих послуг. Він формується на етапі створення комерційної пропозиції і може бути як присутнім, так і відсутнім."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepRepair-13"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content="У цьому списку можна призначити або змінити механіка для кожної послуги. За замовчуванням встановлюється майстер, який проводив діагностику."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepRepair-14"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content="Також тут можна змінити статус виконання послуги, відмітивши чекбокс «Готово»."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepRepair-15"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content="І ще є можливість переглянути вартість робіт та суму зарплати механіка, яка розраховується за його відсотковою ставкою."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepRepair-15"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content="Для повного завершення ремонту авто всі послуги повинні мати призначеного механіка та відмічений статус готовності."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepRepair-17"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content="У нижньому лівому куті модального вікна відображається загальна сума ремонту по авто."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepRepair-18"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content="Також, тут же знаходиться залишок до оплати (якщо був внесений аванс, ця сума буде меншою за загальну суму ремонту)."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepRepair-19"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content="По натисканню на кнопку «Оплатити» відкривається модальне вікно з можливістю проведення платежу."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepRepair-20"]',
    content: () => (
      <TutorialPopover
        title="Ремонт"
        content="Після завершення ремонту індикатор на кнопці стане зеленого  кольору ."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
];

export const notificationSteps = [
  {
    selector: '[data-tour-inwork="stepNotification-1"]',
    content: () => (
      <TutorialPopover
        title="Нагадування"
        content="Для створення нагадування натисніть кнопку з зображенням будильника."
        disabledNext={true}
      />
    ),
    styles: styles,
    stepInteraction: true,
    pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepNotification-2"]',
    content: () => (
      <TutorialPopover
        title="Нагадування"
        content="Модальне вікно “Нагадування” дозволяє створити нагадування про майбутній контакт з клієнтом з приводу його наступного ТО, певних персональних пропозицій або акцій, огляду після ремонту тощо."
        // disabledNext={true}
        disabledBack={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepNotification-3"]',
    content: () => (
      <TutorialPopover
        title="Нагадування"
        content="Оберіть зручний спосіб зв’язку з клієнтом у випадаючому меню. Це може бути один з трьох варіантів: передзвонити, написати листа або зв’язатись за допомогою месенджера (Telegram за замовчуванням)."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepNotification-4"]',
    content: () => (
      <TutorialPopover
        title="Нагадування"
        content="Також оберіть один з можливих варіантів приводу для нагадування зв’язатися з клієнтом в наступному випадаючому меню."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepNotification-4.1"]',
    content: () => (
      <TutorialPopover
        title="Нагадування"
        content="За бажанням можна додати кілометраж на якому бажано провести наступне ТО."
        // disabledNext={true}
      />
    ),
    styles: styles,
    //   stepInteraction: true,
    //   pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepNotification-5"]',
    content: () => (
      <TutorialPopover
        title="Нагадування"
        content="Обов’язково необхідно додати дату та час нагадування."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepNotification-6"]',
    content: () => (
      <TutorialPopover
        title="Нагадування"
        content="Додайте коментар за бажанням (він не є обов'язковим)."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
  {
    selector: '[data-tour-inwork="stepNotification-7"]',
    content: () => (
      <TutorialPopover
        title="Нагадування"
        content="Щоб нагадування створилось, натисніть кнопку “Створити нагадування”. Всі створенні нагадування автоматично додаються до календаря на сторінку “Рекомендації”, де можна переглянути всі деталі створеного нагадування."
        // disabledNext={true}
      />
    ),
    styles: styles,
    // stepInteraction: true,
    // pulse: true,
  },
];
